import React, { Component } from 'react'

import withStyles from '@material-ui/core/styles/withStyles';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Slide from '@material-ui/core/Slide';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardMedia from '@material-ui/core/CardMedia';
import CircularProgress from '@material-ui/core/CircularProgress';
import CardContent from '@material-ui/core/CardContent';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContentText from '@material-ui/core/DialogContentText';
import LinearProgress from '@material-ui/core/LinearProgress';
import Box from '@material-ui/core/Box';

import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';

import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import { authMiddleWare } from '../util/auth';
import Languages from '../components/supportedLanguages';
import { languagesArray } from '../components/supportedLanguages';
import { Switch } from '@material-ui/core'

import functionsApi from '../api';

const firebase = require('firebase');

const styles = (theme) => ({
	switchGrid: {
		width: '200px',
	},
	dialog: {
		margin: 100
	},
	switchContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
		height: '50px',
    },
	progressBar: {
		width: '100%'
	},
	backdrop: {
		zIndex: 9999999,
		color: '#fff',
	},
	content: {
		flexGrow: 1,
		padding: theme.spacing(3),
	},
	toolbar: theme.mixins.toolbar,
	title: {
		marginLeft: theme.spacing(2),
		flex: 1
	},
	submitButton: {
		display: 'block',
		color: 'white',
		textAlign: 'center',
		position: 'absolute',
		top: 14,
		right: 10
	},
	floatingButton: {
		position: 'fixed',
		bottom: 30,
		right: 30
	},
	form: {
		margin: 13,
	},
	gridList: {
		width: '100%',
		height: '100%',
	},
	root: {
		minWidth: 470
	},
	bullet: {
		display: 'inline-block',
		margin: '0 2px',
		transform: 'scale(0.8)'
	},
	pos: {
		marginBottom: 12
	},
	uiProgess: {
		position: 'fixed',
		zIndex: '1000',
		height: '31px',
		width: '31px',
		left: '50%',
		top: '35%'
	},
	dialogeStyle: {
		maxWidth: '50%'
	},
	viewRoot: {
		margin: 0,
		padding: theme.spacing(2)
	},
	closeButton: {
		position: 'absolute',
		right: theme.spacing(1),
		top: theme.spacing(1),
		color: theme.palette.grey[500]
	},
	appBar: {
		position: 'inherit'
	},
	cardRoot: {
		maxWidth: 350,
		margin: 5,
	},
	cardMedia: {
		height: 350,
		width: 350,
		maxWidth: 350,
	},
	formControl: {
		minWidth: 120,
	},
	gridListRoot: {
		display: 'flex',
		flexWrap: 'wrap',
		justifyContent: 'center',
		width: '100%',
		height: '100%',
	}
});

const Transition = React.forwardRef(function Transition(props, ref) {
	return <Slide direction="up" ref={ref} {...props} />;
});

class workout extends Component {
	constructor(props) {
		super(props);

		this.state = {
			workouts: '',
			promoVideoURL: '',
			id: '',
			isActive: '',
			errors: [],
			open: false,
			deleteOpen: false,
			uiLoading: true,
			buttonType: 'Create',
			viewOpen: false,
			contents: [],
			supportedLang: [],
			workInProgress: false,
			promoUploadProgress: 0,
			videoUploadProgress: 0,
			viewCount: 0
		};

		if (props.trainer) {
			this.setState({
				trainer: props.trainer.id
			})
		}

		this.handleClickDelete = this.handleClickDelete.bind(this);
		this.handleEditClickOpen = this.handleEditClickOpen.bind(this);
	}

	handleChange = (event) => {
		this.setState({
			[event.target.name]: event.target.value
		});
	};

	handleLanguageChange = (event) => {

		const items = []
		const supportedLang = []

		for (const [index, value] of event.entries()) {
			if (typeof this.state.contents[index] === 'undefined') {
				items.push({ id: index, language: value.code, languageDescription: value.label, title: value.title, description: value.description })
			} else {
				var title = this.state.contents[index].description
				var description = this.state.contents[index].description
				items.push({ id: index, language: value.code, languageDescription: value.label, title: title, description: description })
			}
			supportedLang.push(value.code)
		}

		this.setState({
			contents: items,
			supportedLang: supportedLang
		});
	};

	handleDescriptionChange = (event) => {
		var items = this.state.contents
		var item = items[event.target.id];

		item.description = event.target.value
		items[event.target.id] = item

		this.setState({
			contents: items
		});
	};

	handleTitleChange = (event) => {
		var items = this.state.contents
		var item = items[event.target.id];

		item.title = event.target.value
		items[event.target.id] = item

		this.setState({
			contents: items
		});
	};

	handleSongURIChange = (event) => {
		this.setState({
			songURI: event.target.value
		});
	};

	componentWillMount = () => {
		authMiddleWare(this.props.history);

		var request = null

		if (this.props.trainer.isAdmin) {
			request = functionsApi
				.get('/getAllWorkouts')
		} else {
			request = functionsApi
				.get('/getAllWorkoutsByTrainer?trainerId=' + this.props.trainer.id)
		}

		request
			.then((response) => {
				this.setState({
					workouts: response.data,
					uiLoading: false
				});
			})
			.catch((err) => {
				console.log(err);
			});
	};

	handleClickDelete(data) {
		this.setState({
			deleteOpen: true,
			workoutToDelete: data
		});
	}

	handleEditClickOpen(data) {
		this.setState({
			id: data.todo.id,
			isActive: data.todo.isActive,
			promoVideoURL: data.todo.promoVideoURL,
			videoURL: data.todo.videoURL,
			videoThumbURL: data.todo.videoThumbURL,
			intensity: data.todo.intensity,
			style: data.todo.style,
			contents: data.todo.contents,
			supportedLang: data.todo.supportedLang,
			duration: data.todo.duration,
			songURI: data.todo.songURI,
			viewCount: data.todo.viewCount,
			buttonType: 'Edit',
			open: true,
			deleteOpen: false
		});
	}

	isContentEmpty() {
		var found = false;
		for (const [index, value] of this.state.contents.entries()) {
			if (!value.title || !value.description) {
				found = true;
			}
		}
		return found
	}

	uploadVideo(item) {
		const uploadTask = firebase.storage().ref().child(`video_upload/${item.folder}/${item.file.name}`).put(item.file)
		uploadTask
			.on('state_changed', function (snapshot) {
				if (item.uploadProgress) {
					var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
					this.setState({ [item.uploadProgress]: progress })
				}
			}.bind(this), function (error) {
				console.log('ERROR', error)
			}, function () {
				uploadTask.snapshot.ref.getDownloadURL().then(function (downloadURL) {
					return downloadURL
				})
			})
		return uploadTask
	}

	renderDanceComponents(param) {
		const { classes } = this.props;
		const { errors } = this.state;
		if (this.state.style === "DANCE") {
			return <Grid container spacing={2}>
				<Grid item md={6} xs={12}>
					<FormControl fullWidth variant="outlined">
						<InputLabel id="style">Style</InputLabel>
						<Select
							labelId="style"
							id="style"
							name="style"
							onChange={this.handleChange}
							label="style"
							autoWidth
							value={this.state.style}
						>
							<MenuItem value="">
								<em>None</em>
							</MenuItem>
							<MenuItem value={"HIIT"}>HIIT</MenuItem>
							<MenuItem value={"TABATA"}>Tabata</MenuItem>
							<MenuItem value={"YOGA"}>Yoga</MenuItem>
							<MenuItem value={"DANCE"}>Dance</MenuItem>
							<MenuItem value={"FUNCTIONAL"}>Functional</MenuItem>
							<MenuItem value={"MOBILITY"}>Mobility</MenuItem>
							<MenuItem value={"RUNNING"}>Running</MenuItem>
						</Select>
					</FormControl>
				</Grid>
				<Grid item md={6} xs={12}>
					<TextField
						variant="outlined"
						required
						fullWidth
						id="songURI"
						label="Spotify Song URI"
						name="songURI"
						autoComplete="songURI"
						type="text"
						helperText={errors.songURI}
						value={this.state.songURI}
						error={errors.songURI ? true : false}
						onChange={this.handleSongURIChange}
					/>
				</Grid>
			</Grid>
		} else {
			return <Grid container spacing={2}>
				<Grid item md={6} xs={12}>
					<FormControl fullWidth variant="outlined">
						<InputLabel id="style">Style</InputLabel>
						<Select
							labelId="style"
							id="style"
							name="style"
							onChange={this.handleChange}
							label="style"
							autoWidth
							value={this.state.style}
						>
							<MenuItem value="">
								<em>None</em>
							</MenuItem>
							<MenuItem value={"HIIT"}>HIIT</MenuItem>
							<MenuItem value={"TABATA"}>Tabata</MenuItem>
							<MenuItem value={"YOGA"}>Yoga</MenuItem>
							<MenuItem value={"DANCE"}>Dance</MenuItem>
							<MenuItem value={"FUNCTIONAL"}>Functional</MenuItem>
							<MenuItem value={"MOBILITY"}>Mobility</MenuItem>
							<MenuItem value={"RUNNING"}>Running</MenuItem>
						</Select>
					</FormControl>
				</Grid>
			</Grid>
		}
	}

	render() {
		const DialogTitle = withStyles(styles)((props) => {
			const { children, classes, onClose, ...other } = props;
			return (
				<MuiDialogTitle disableTypography className={classes.root} {...other}>
					<Typography variant="h6">{children}</Typography>
					{onClose ? (
						<IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
							<CloseIcon />
						</IconButton>
					) : null}
				</MuiDialogTitle>
			);
		});

		const DialogContent = withStyles((theme) => ({
			viewRoot: {
				padding: theme.spacing(2)
			}
		}))(MuiDialogContent);

		dayjs.extend(relativeTime);
		const { classes } = this.props;
		const { open, errors, deleteOpen, workInProgress, promoUploadProgress, videoUploadProgress } = this.state;

		const handleClickOpen = () => {
			this.setState({
				id: '',
				isActive: '',
				promoVideoURL: '',
				videoThumbURL: '',
				videoURL: '',
				buttonType: 'Create',
				trainer: this.props.trainer,
				style: '',
				intensity: '',
				songURI: '',
				open: true,
				errors: [],
				contents: [],
				supportedLang: [],
				deleteOpen: false,
				video: ''
			});
		};

		const handleClickDelete = () => {
			this.setState({
				deleteOpen: false
			});

			authMiddleWare(this.props.history);
			functionsApi
				.delete(`/deleteWorkout/${this.state.workoutToDelete.todo.id}`)
				.then(() => {
					window.location.reload();
				})
				.catch((err) => {
					console.log(err);
				});
		};

		const handlePromoVideoChange = (event) => {
			this.setState({
				promoVideo: event.target.files[0]
			});
		};
		const handleWorkoutVideoChange = (event) => {
			this.setState({
				workoutVideo: event.target.files[0]
			});
		};
		const handleThumbnailImageChange = (event) => {
			this.setState({
				thumbnailImage: event.target.files[0]
			});
		};

		const toggleWorkInProgress = () => {
			this.setState({ workInProgress: !this.state.workInProgress })
		}

		const uploadFiles = async () => {
			const dateArray = new Date().toISOString().split('-')
			const yearAndMonth = dateArray[0] + "-" + dateArray[1]
			const instant = new Date().getTime()
			return await Promise.all([
				this.uploadVideo({ file: this.state.promoVideo, folder: `${yearAndMonth}/${instant}/promo`, uploadProgress: 'promoUploadProgress' }),
				this.uploadVideo({ file: this.state.workoutVideo, folder: `${yearAndMonth}/${instant}/video`, uploadProgress: 'videoUploadProgress' }),
				this.uploadVideo({ file: this.state.thumbnailImage, folder: `${yearAndMonth}/${instant}/` })
			]).then(([promo, video, thumbnail]) => {
				const promoPath = encodeURIComponent(promo.metadata.fullPath.substring(0, promo.metadata.fullPath.lastIndexOf('/')) + '/hls/')
				const videoPath = encodeURIComponent(video.metadata.fullPath.substring(0, video.metadata.fullPath.lastIndexOf('/')) + '/hls/')
				const thumbnailPath = encodeURIComponent(thumbnail.metadata.fullPath)

				const promoFullPath = `https://firebasestorage.googleapis.com/v0/b/${promo.metadata.bucket}/o/${promoPath}index.m3u8?alt=media`
				const videoFullPath = `https://firebasestorage.googleapis.com/v0/b/${video.metadata.bucket}/o/${videoPath}index.m3u8?alt=media`
				const thumbnailFullPath = `https://firebasestorage.googleapis.com/v0/b/${thumbnail.metadata.bucket}/o/${thumbnailPath}?alt=media`

				return {
					promoFullPath: promoFullPath,
					videoFullPath: videoFullPath,
					thumbnailFullPath: thumbnailFullPath
				}
			})
		}

		const handleSubmit = async (event) => {
			authMiddleWare(this.props.history);
			event.preventDefault();

			console.log('###workout:', this.state)

			if (this.state.buttonType === 'Create') {
				var errors = {}
				if (!this.state.promoVideo) errors.promoVideo = "Promo video must be present"
				if (!this.state.workoutVideo) errors.workoutVideo = "Workout video must be present"
				if (!this.state.thumbnailImage) errors.thumbnailImage = "ThumbnailImage must be present"
				if (this.state.style === 'DANCE' && this.state.songURI.length <= 0) errors.songURI = "Song URI must be present"

				if (Object.keys(errors).length > 0) {
					this.setState({
						errors: errors
					});
					return
				}
			}

			toggleWorkInProgress()
			var paths
			if (this.state.buttonType === 'Create') {
				paths = await uploadFiles()
			}

			const workout = {
				id: this.state.id,
				supportedLang: this.state.supportedLang,
				contents: this.state.contents,
				style: this.state.style,
				intensity: this.state.intensity,
				duration: parseInt(this.state.duration),
				promoVideoURL: this.state.buttonType === 'Create' ? paths.promoFullPath : this.state.promoVideoURL,
				videoURL: this.state.buttonType === 'Create' ? paths.videoFullPath : this.state.videoURL,
				videoThumbURL: this.state.buttonType === 'Create' ? paths.thumbnailFullPath : this.state.videoThumbURL,
				viewCount: this.state.viewCount,
				songURI: this.state.songURI
			};

			let options = {};
			if (this.state.buttonType === 'Edit') {
				options = {
					url: `/editWorkout/${this.state.id}`,
					method: 'put',
					data: workout
				};
			} else {
				options = {
					url: '/postWorkout',
					method: 'post',
					data: workout
				};
			}

			console.log('###workout:', workout)

			functionsApi(options)
				.then(() => {
					this.setState({ open: false });
					window.location.reload();
				})
				.catch((error) => {
					this.setState({ open: true, errors: error.response.data });
					console.log(error);
					toggleWorkInProgress();
				});
		};

		const toggleChecked = async (event) =>  {
			authMiddleWare(this.props.history);
			event.preventDefault();

			const workout = {
				id: this.state.id,
				isActive: event.target.checked,
				uiLoading: true
			};

			let options = {
				url: `/editWorkout/${this.state.id}`,
				method: 'put',
				data: workout
			};

			functionsApi(options)
				.then(() => {
					window.location.reload();
				})
				.catch((error) => {
					this.setState({ open: true, errors: error.response.data });
					console.log(error);
				});
		};

		const handleClose = (event) => {
			this.setState({ open: false });
		};

		const handleCloseDelete = (event) => {
			this.setState({ deleteOpen: false });
		};

		if (this.state.uiLoading === true) {
			return (
				<main className={classes.content}>
					<div className={classes.toolbar} />
					{this.state.uiLoading && <CircularProgress className={classes.uiProgess} />}
				</main>
			);
		} else {
			return (
				<main className={classes.content}>
					<div className={classes.toolbar} />

					<Dialog className={classes.dialog} fullScreen open={open} onClose={handleClose} TransitionComponent={Transition}>
						<AppBar className={classes.appBar}>
							<Toolbar>
								<IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close">
									<CloseIcon />
								</IconButton>
								<Typography variant="h6" className={classes.title}>
									{this.state.buttonType === 'Edit' ? 'Edit Workout' : 'Create a new Workout'}
								</Typography>
								<Grid container spacing={2} className={classes.switchGrid}>
								<Button
									autoFocus
									color="inherit"
									onClick={handleSubmit}
									className={classes.submitButton}
									disabled={
										!this.state.style ||
										!this.state.intensity ||
										!this.state.duration ||
										(!this.state.supportedLang || this.state.supportedLang.length <= 0) ||
										(!this.state.contents || this.state.contents.length <= 0) ||
										this.isContentEmpty()
									}
								>
									{this.state.buttonType === 'Edit' ? 'Save' : 'Create'}
								</Button>
								{ this.props.trainer.isAdmin ?
									<div className={classes.switchContainer}>
										Avaliable
										<Switch size="small" checked={this.state.isActive} onChange={toggleChecked} />
									</div>
									: <div/>
								}
								</Grid>
							</Toolbar>
						</AppBar>

						<form className={classes.form} noValidate>
							<Grid container spacing={2}>
								{ this.renderDanceComponents() }
								<Grid item md={6} xs={12}>
									<FormControl fullWidth variant="outlined" className={classes.formControl}>
										<InputLabel id="intensity">Intensity</InputLabel>
										<Select
											labelId="intensity"
											id="intensity"
											name="intensity"
											onChange={this.handleChange}
											label="intensity"
											autoWidth
											value={this.state.intensity}
										>
											<MenuItem value="">
												<em>None</em>
											</MenuItem>
											<MenuItem value={"beginner"}>Beginner</MenuItem>
											<MenuItem value={"intermediate"}>Intermediate</MenuItem>
											<MenuItem value={"advanced"}>Advanced</MenuItem>
										</Select>
									</FormControl>
								</Grid>
								<Grid item md={6} xs={12}>
									<TextField
										variant="outlined"
										required
										fullWidth
										id="duration"
										label="Workout Duration (Seconds)"
										name="duration"
										autoComplete="duration"
										type="number"
										helperText={errors.duration}
										value={this.state.duration}
										error={errors.duration ? true : false}
										onChange={this.handleChange}
									/>
								</Grid>
								<Grid item md={6} xs={12}>
									<Languages
										variant="outlined"
										required
										fullWidth
										id="supportedLang"
										label="Select the languages for your workout"
										name="supportedLang"
										autoComplete="supportedLang"
										items={this.state.supportedLang.flatMap((code) => languagesArray.filter(obj => {
											return obj.code === code
										}))}
										onChange={this.handleLanguageChange}
									/>
								</Grid>

								<div className={classes.gridListRoot}>

									{this.state.contents.map((content) => (
										<Card md={12} className={classes.cardRoot}>
											<CardContent>
												<Grid container spacing={2}>
													<Grid item xs={12}>
														<TextField
															variant="outlined"
															required
															fullWidth
															name={content.title}
															label={content.languageDescription + ' title'}
															type="contents"
															id={content.id}
															autoComplete="contents"
															value={content.title}
															onChange={this.handleTitleChange}
														/>
													</Grid>
													<Grid item xs={12}>
														<TextField
															variant="outlined"
															required
															fullWidth
															name={content.description}
															multiline
															rows={4}
															label={content.languageDescription + ' description'}
															type="contents"
															id={content.id}
															autoComplete="contents"
															value={content.description}
															onChange={this.handleDescriptionChange}
														/>
													</Grid>
												</Grid>
											</CardContent>
										</Card>
									))}
								</div>

								<Grid item xs={12}>
									<label htmlFor="promoVideo">
										<input
											style={{ display: 'none' }}
											id="promoVideo"
											name="promoVideo"
											type="file"
											onChange={handlePromoVideoChange}
										/>
										<div><span style={{ color: "red" }}>{errors.promoVideo}</span></div>
										<Fab
											color="secondary"
											size="small"
											component="span"
											aria-label="add"
											variant="extended">
											<AddIcon /> Promo Video
  									</Fab>
										{this.state.promoVideo && this.state.promoVideo.name}
									</label>
								</Grid>
								<Grid item xs={12}>
									<label htmlFor="workoutVideo">
										<input
											style={{ display: 'none' }}
											id="workoutVideo"
											name="workoutVideo"
											type="file"
											onChange={handleWorkoutVideoChange}
										/>
										<div><span style={{ color: "red" }}>{errors.workoutVideo}</span></div>
										<Fab
											color="secondary"
											size="small"
											component="span"
											aria-label="add"
											variant="extended">
											<AddIcon /> Workout Video
  									</Fab>
										{this.state.workoutVideo && this.state.workoutVideo.name}
									</label>
								</Grid>
								<Grid item xs={12}>
									<img style={{ width: "350px" }} src={this.state.videoThumbURL} />
									<label htmlFor="thumbnailImage">
										<input
											style={{ display: 'none' }}
											id="thumbnailImage"
											name="thumbnailImage"
											type="file"
											onChange={handleThumbnailImageChange}
										/>
										<div><span style={{ color: "red" }}>{errors.thumbnailImage}</span></div>
										<Fab
											color="secondary"
											size="small"
											component="span"
											aria-label="add"
											variant="extended">
											<AddIcon /> Workout Thumbnail
  									</Fab>
										{this.state.thumbnailImage && this.state.thumbnailImage.name}
									</label>
								</Grid>
							</Grid>
						</form>
					</Dialog>

					<Dialog
						open={deleteOpen}
						onClose={handleCloseDelete}
						aria-labelledby="alert-dialog-title"
						aria-describedby="alert-dialog-description"
					>
						<DialogTitle id="alert-dialog-title">{"Are you sure?"}</DialogTitle>
						<DialogContent>
							<DialogContentText id="alert-dialog-description">
								Deleting a workout will make it imediatelly unavaliable to the users and remove it completelly from the H&T plataform. Do you want to proceed?
							</DialogContentText>
						</DialogContent>
						<DialogActions>
							<Button onClick={handleCloseDelete} color="primary">
								Cancel
						</Button>
							<Button onClick={handleClickDelete} color="secondary" autoFocus>
								Delete
						</Button>
						</DialogActions>
					</Dialog>

					<div className={classes.gridListRoot}>
						<Grid container alignItems="center" justify="center" spacing={2}>
							{this.state.workouts.map((workout, i) => (
								<Card className={classes.cardRoot} key={i}>
									<CardActionArea>
										<CardMedia
											className={classes.cardMedia}
											image={workout.videoThumbURL}
										/>
										<CardContent>
											<Grid>
													{workout.isActive ? "Active" : <Box color="red"> Inactive</Box>}
											</Grid>
											<Typography noWrap variant="caption" color="textSecondary" >
												{workout.id}
											</Typography>

											<Typography gutterBottom variant="h6" component="h2">
												{workout.contents[0].title}
											</Typography>
											<Typography variant="body2" component="p">
												{dayjs(workout.createdAt).fromNow()}
											</Typography>
											<Typography noWrap variant="body2" color="textSecondary" >
												{(workout.duration / 60).toFixed(0) + ":" + workout.duration%60 +  " min" + " | " + workout.intensity + " | " + workout.style}
											</Typography>
											<Typography noWrap variant="body2" color="textSecondary" >
												{workout.contents[0].description}
											</Typography>
										</CardContent>
									</CardActionArea>
									<CardActions>
										<Button size="small" color="primary" onClick={() => this.handleEditClickOpen({ todo: workout, isAdmin: this.props.trainer.isAdmin})}>
											Edit
										</Button>
										<Button size="small" color="secondary" onClick={() => this.handleClickDelete({ todo: workout })}>
											Delete
										</Button>
									</CardActions>
								</Card>
							))}
						</Grid>

						<Fab variant="extended" className={classes.floatingButton} onClick={handleClickOpen}>
							<AddIcon className={classes.extendedIcon} />
 							 Add training
						</Fab>
					</div>

					<Dialog
						open={workInProgress}
						aria-labelledby="alert-dialog-title"
						aria-describedby="alert-dialog-description">
						<DialogTitle id="alert-dialog-title">{"Uploading workout"}</DialogTitle>
						<DialogContent>
							Promo:
							<div className={classes.progressBar}>
								<LinearProgressWithLabel value={promoUploadProgress} />
							</div>
							Video:
							<div className={classes.progressBar}>
								<LinearProgressWithLabel value={videoUploadProgress} />
							</div>
						</DialogContent>
					</Dialog>
				</main>
			);
		}
	}
}

function LinearProgressWithLabel(props) {
	return (
		<Box display="flex" alignItems="center">
			<Box width="100%" mr={1}>
				<LinearProgress variant="determinate" {...props} />
			</Box>
			<Box minWidth={35}>
				<Typography variant="body2" color="textSecondary">{`${Math.round(
					props.value,
				)}%`}</Typography>
			</Box>
		</Box>
	);
}

export default withStyles(styles)(workout);
